import { createI18n } from "vue-i18n";
import en from "./en";
import cn from "./ch-cn";
import br from "./br";
import tw from "./ch-tw";
import de from "./de";
import es from "./es";
import fr from "./fr";
import it from "./it";
import jp from "./jp";
import ko from "./ko";
const i18n = createI18n({
  locale: localStorage.getItem("language") || "en", // 默认是中文
  //   fallbackLocale: 'en', // 语言切换的时候是英文
  globalInjection: true, //全局配置$t
  legacy: true, //vue3写法
  messages: { en, cn, br, de, es, fr, it, jp, tw, ko }, // 需要做国际化的语种,就是刚才编写的两个语言
});

export default i18n;
